const timezones = [
    { value: "UTC−12:00", label: "UTC−12:00 (Baker Island)" },
    { value: "UTC−11:00", label: "UTC−11:00 (American Samoa)" },
    { value: "UTC−10:00", label: "UTC−10:00 (Hawaii)" },
    { value: "UTC−09:00", label: "UTC−09:00 (Alaska)" },
    { value: "UTC−08:00", label: "UTC−08:00 (Pacific Time - US & Canada)" },
    { value: "UTC−07:00", label: "UTC−07:00 (Mountain Time - US & Canada)" },
    { value: "UTC−06:00", label: "UTC−06:00 (Central Time - US & Canada)" },
    { value: "UTC−05:00", label: "UTC−05:00 (Eastern Time - US & Canada)" },
    { value: "UTC−04:00", label: "UTC−04:00 (Atlantic Time - Canada)" },
    { value: "UTC−03:00", label: "UTC−03:00 (Buenos Aires)" },
    { value: "UTC−02:00", label: "UTC−02:00 (South Georgia & Sandwich Is.)" },
    { value: "UTC−01:00", label: "UTC−01:00 (Azores)" },
    { value: "UTC±00:00", label: "UTC±00:00 (London, Lisbon, Casablanca)" },
    { value: "UTC+01:00", label: "UTC+01:00 (Paris, Berlin, Rome, Madrid)" },
    { value: "UTC+02:00", label: "UTC+02:00 (Athens, Cairo, Jerusalem)" },
    { value: "UTC+03:00", label: "UTC+03:00 (Moscow, Nairobi, Riyadh)" },
    { value: "UTC+04:00", label: "UTC+04:00 (Dubai, Samara)" },
    { value: "UTC+05:00", label: "UTC+05:00 (Karachi, Tashkent)" },
    { value: "UTC+06:00", label: "UTC+06:00 (Dhaka, Almaty)" },
    { value: "UTC+07:00", label: "UTC+07:00 (Bangkok, Hanoi, Jakarta)" },
    { value: "UTC+08:00", label: "UTC+08:00 (Beijing, Hong Kong, Singapore)" },
    { value: "UTC+09:00", label: "UTC+09:00 (Asia/Seoul, Tokyo)" },
    { value: "UTC+10:00", label: "UTC+10:00 (Sydney, Vladivostok)" },
    { value: "UTC+11:00", label: "UTC+11:00 (Solomon Islands)" },
    { value: "UTC+12:00", label: "UTC+12:00 (Auckland, Fiji)" },
];

export default timezones;
